import { AxiosProgressEvent } from 'axios';
import { uploadClient } from 'utils/upload/uploadClient';

export interface PresignedUploadTarget {
  storageUrl: string;
  callbackUrl: string;
  callbackToken: string;
  callbackBody: Record<string, unknown>;
}

export interface PresignedUploadOptions {
  signal?: AbortSignal;
  onUploadProgress?: (event: AxiosProgressEvent) => void;
}

export interface PresignedUploadResult {
  link: string;
}

export const uploadPresignedFile = async (
  blob: Blob,
  target: PresignedUploadTarget,
  options: PresignedUploadOptions = {}
): Promise<PresignedUploadResult> => {
  const contentType = blob.type || 'application/octet-stream';

  await uploadClient.put(target.storageUrl, blob, {
    headers: { 'Content-Type': contentType },
    signal: options.signal,
    onUploadProgress: options.onUploadProgress,
  });

  const { data } = await uploadClient.post<PresignedUploadResult>(
    target.callbackUrl,
    target.callbackBody,
    {
      headers: {
        Authorization: `Bearer ${target.callbackToken}`,
        'Content-Type': 'application/json',
      },
      signal: options.signal,
    }
  );

  return data;
};
